//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_oneOverPi = 0.3183098861837907;\n\
";
